import React from 'react';

import { Icon } from '@chakra-ui/react';

export const RepairIcon = props => (
  <Icon viewBox="0 0 30 30" color="inherit" h="full" w="full" {...props}>
    <g id="layer1" transform="translate(0,-289.0625)">
      <path
        d="m 24.775889,297.28984 -3.995429,3.99543 -2.828427,-2.82843 3.994048,-3.99404 a 6,6 0 0 0 -6.822475,1.16562 6,6 0 0 0 -1.548177,5.79082 l -6.9371048,6.9371 c -1.1752115,1.17521 -1.1752115,3.06743 0,4.24264 1.1752115,1.17521 3.0674292,1.17521 4.2426408,0 l 6.938485,-6.93848 a 6,6 0 0 0 5.789437,-1.5468 6,6 0 0 0 1.167002,-6.82386 z"
        id="rect1084"
        opacity={1}
        fill="currentColor"
        strokeWidth={1.99999988}
        strokeMiterlimit={4}
        strokeDasharray="none"
        strokeOpacity={1}
        stroke="none"
        fillOpacity={1}
      />
    </g>
  </Icon>
);
